export enum WidgetGroupModalType {
  newGroup = "new-group",
  renameGroup = "rename-group",
}
